class UserList {
    constructor({
        _id = "",
        profile_picture = "",
        fcm_token = "",
        is_deleted = false,
        created_at = "",
        updated_at = "",
        name = "",
        email = "",
        device_type = "",
        isPremiumUser = "false",
        projectCount = 0,
        __v = 0
    }) {
        this._id = _id;
        this.profile_picture = profile_picture;
        this.fcm_token = fcm_token;
        this.is_deleted = is_deleted;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.name = name;
        this.email = email;
        this.device_type = device_type;
        this.isPremiumUser = isPremiumUser,
        this.projectCount = projectCount,
        this.__v = __v;
    }
}

class UserModel {
    constructor({
        users = [],
        totalPages = 0,
        currentPage = 1,
        totalUsers = 0,
        hasNextPage = false
    }) {
        this.users = users.map(user => new UserList(user));
        this.totalPages = totalPages;
        this.currentPage = currentPage;
        this.totalUsers = totalUsers;
        this.hasNextPage = hasNextPage;
    }
}

export { UserList, UserModel };
